import { resolveApiBase } from '../utils/httpClient';

/** Gateway Swagger — never the React dev-server origin (that 404s on :3000/:3002). */
export function swaggerHref() {
  const base = resolveApiBase();
  return `${base}/swagger/`;
}

export const PUBLIC_NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/partners', label: 'Partners' },
  { to: '/tutorials', label: 'Tutorials' },
  { to: '/about', label: 'About' },
  { to: '/help-support', label: 'Help & Support' },
  { to: '/admin/login', label: 'Super admin' },
  { to: swaggerHref, label: 'Swagger', external: true },
];

export const PUBLIC_JOIN_LINKS = [
  { to: '/register/candidate', label: 'Join as Candidate', type: 'candidate' },
  { to: '/register/consultancy', label: 'Join as Consultancy', type: 'consultancy' },
  { to: '/register/institution', label: 'Join as Institution', type: 'institution' },
  { to: '/register/partner', label: 'Join as EdTech partner', type: 'partner' },
];

export const PUBLIC_FOOTER_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/partners', label: 'Partners' },
  { to: '/tutorials', label: 'Tutorials' },
  { to: '/help-support', label: 'Support' },
  { to: swaggerHref, label: 'Swagger', external: true },
];

export const isPublicJoinActive = (pathname, to) => {
  if (pathname === to) return true;
  if (to === '/register/candidate' && (pathname === '/register' || pathname === '/register/student')) {
    return true;
  }
  return false;
};

export const joinIconName = (type) => {
  if (type === 'consultancy') return 'users';
  if (type === 'institution') return 'briefcase';
  if (type === 'partner') return 'book';
  return 'user';
};
